import IcCalendarNeutral from 'assets/Icons/Calendar/IcCalendarNeutral';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { changeAssessmentApiResponse } from 'models/Tablet/AssessmentApiTypes';
import styled from 'styled-components';
import { OpacityColor, TextColor } from 'styles/Global/colorSemantic';
import { ColumnDivider } from 'styles/Global/commonStyles';
import { Body3SemiBold, Body5Medium, Caption1Medium, Caption1Regular } from 'styles/Global/typography';
import { parseBirthDay } from 'utils/calculateAge';
import { formatDateFlexible } from 'utils/calculateTime';
import { getRelationText } from 'utils/getTypeText';
import { DiagnosisStatus } from 'utils/statusCode';

const AiInspectorInfo = ({ diagnosisInfo }: { diagnosisInfo: changeAssessmentApiResponse }) => {
    return (
        <InfoContainer>
            <NameAndGenderContainer>
                <Body3SemiBold>{diagnosisInfo.patientName}</Body3SemiBold>
                {diagnosisInfo.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $width='16px' $height='16px' />}
            </NameAndGenderContainer>
            <InfoContentsContainer>
                <InfoSectionContainer>
                    <div style={{ width: '80px' }}>
                        <Caption1Regular $color={TextColor.color_text_light}>자녀 생년월일</Caption1Regular>
                    </div>
                    <Body5Medium>{parseBirthDay(diagnosisInfo.patientIdentityNumber)}</Body5Medium>
                </InfoSectionContainer>
                <InfoSectionContainer>
                    <div style={{ width: '80px' }}>
                        <Caption1Regular $color={TextColor.color_text_light}>자녀 학령학기</Caption1Regular>
                    </div>
                    <Body5Medium>{diagnosisInfo.gradeName}</Body5Medium>
                </InfoSectionContainer>
                <InfoSectionContainer>
                    <div style={{ width: '80px' }}>
                        <Caption1Regular $color={TextColor.color_text_light}>주양육자</Caption1Regular>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Body5Medium>{getRelationText(diagnosisInfo.relationType)}</Body5Medium>
                        <ColumnDivider $height='12px' />
                        <Body5Medium>{diagnosisInfo.parentName}</Body5Medium>
                    </div>
                </InfoSectionContainer>
                {diagnosisInfo.status === DiagnosisStatus.counselReserved && (
                    <ReservationInfoContainer>
                        <ReservationTitle>
                            <IcCalendarNeutral />
                            <Caption1Medium $color={TextColor.color_text_light}>상담 일시</Caption1Medium>
                        </ReservationTitle>
                        <ColumnDivider $height='12px' />
                        <Body5Medium>{formatDateFlexible(diagnosisInfo.diagnosisDateTime, 'YYYY/MM/DD a hh:mm', 'YYYYMMDDHHmmss')}</Body5Medium>
                    </ReservationInfoContainer>
                )}
            </InfoContentsContainer>
        </InfoContainer>
    );
};
export default AiInspectorInfo;

const InfoContainer = styled.div`
    display: flex;
    background-color: #fff;
    flex-direction: column;
    padding: 12px 16px 14px 16px;
    width: 100%;
    border-radius: 8px;
    gap: 12px;
`;

const InfoContentsContainer = styled.div`
    display: flex;
    background-color: #fff;
    flex-direction: column;
    width: 100%;
    border-radius: 8px;
    gap: 6px;
`;

const ReservationInfoContainer = styled.div`
    display: flex;
    align-items: center;
    background-color: ${OpacityColor.color_opacity_neutral_6};
    border-radius: 4px;
    width: 100%;
    padding: 8px 0px 8px 8px;
    gap: 10px;
`;

const ReservationTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

const NameAndGenderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
`;

const InfoSectionContainer = styled.div`
    display: flex;
    gap: 14px;
`;
